import { render, staticRenderFns } from "./MailSendCreate.vue?vue&type=template&id=5a1b82ed&"
import script from "./MailSendCreate.vue?vue&type=script&lang=js&"
export * from "./MailSendCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports